export abstract class WindowRef {
  public get nativeWindow(): Window | Record<string, void> {
    throw new Error('Window is not implemented');
  }
}
